// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"RS-z","inlineTitle":"SS-z","sponsoredAdsWrapper":"TS-z","marketplaceRecosWrapper":"US-z"};